import { pdfjs } from "react-pdf";
import pdfWorker from "pdfjs-dist/build/pdf.worker.min.js";

export const configurePdfWorker = (): void => {
  pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker;
};

export default configurePdfWorker;
